import React from 'react';
import Header from './Header';
import OrderItem from './OrderItem';
import Footer from './Footer';
import CancelOrder from './template/CancelOrder';
import { useOrderContext } from './OrderContext'; // Импортируем хук

function Layout() {

    return (
        <>
            <Header/>
            <main className='flex-fill mt-3'>
                <div className="container-fluid">
                    <div className="row g-3 mt-3 fw-bold ">
                        <OrderItem />
                    </div>
                </div>
            </main>
            <CancelOrder/>
        </>
    );
}

export default Layout;
